export function SVG_AddArcVerbose(
  xRadius,
  yRadius,
  xAxisRotation,
  largeArcFlag,
  sweep,
  endX,
  endY
) {
  return (
    "A" +
    xRadius +
    "," +
    yRadius +
    ", " +
    xAxisRotation +
    "," +
    largeArcFlag +
    "," +
    sweep +
    ", " +
    endX +
    "," +
    endY +
    " "
  );
}
